import BaseEntityService from '../core/base-entity-service';

export default class AnalyticsService extends BaseEntityService {
  static override route = 'analytics';
}
